import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // Some browsers may not support "instant"
      });
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
